module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"authorizationRequest":"Запрос авторизации","application":"Приложение","requiresAccess":"запрашивает разрешение на доступ к вашему аккаунту.","deny":"Отмена","approve":"Разрешить","chooseAnotherAccount":"Выбрать другой аккаунт","slogan":"Сервис видеособеседований с человеческим лицом"}}')
  delete Component.options._Ctor
}
